import { useQuery, useQueryClient } from '@tanstack/react-query'

import type { BookingSessionResponse } from '../../types/booking-session.js'

import { apiClient } from '../../lib/client.js'
import { syncBookingSessionCache } from './cache.js'
import { bookingSessionKeys } from './keys.js'

export const useFetchPrice = (sessionId: string | undefined) => {
  const queryClient = useQueryClient()

  return useQuery({
    enabled: !!sessionId,
    queryFn: async () => {
      const response = await apiClient.client.get<BookingSessionResponse>(
        `/booking-session/${sessionId}/price`
      )
      syncBookingSessionCache(queryClient, response.data)
      return response.data
    },
    queryKey: sessionId ? bookingSessionKeys.price(sessionId) : bookingSessionKeys.all,
    retry: false,
    staleTime: 5 * 60 * 1000,
  })
}
